<div class="root">
    @if (placeholder === "Search") {
        <div class="flex-100">
            <input
                type="text"
                [ngClass]="placeholder"
                [formControl]="queryControl"
                [matAutocomplete]="auto"
                matInput
                [placeholder]="placeholder"
                (keyup)="$event.preventDefault()"
            />
        </div>
    } @else {
        <mat-form-field>
            <input
                type="text"
                [formControl]="queryControl"
                [matAutocomplete]="auto"
                matInput
                [placeholder]="placeholder"
                (keyup)="$event.preventDefault()"
            />
        </mat-form-field>
    }

    <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        [displayWith]="displayName()"
        (optionSelected)="selectHandler($event)"
    >
        @for (tag of filteredTags | async; track tag) {
            <mat-option [value]="tag">
                @switch (tag.category) {
                    @case ("artist") {
                        <ng-container>
                            <mat-icon>account_box</mat-icon> {{ tag.displayName }}
                        </ng-container>
                    }
                    @default {
                        <ng-container>
                            <mat-icon>label</mat-icon> {{ tag.displayName }}
                        </ng-container>
                    }
                }
            </mat-option>
        }
    </mat-autocomplete>

    @if (queryControl.value) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
            <mat-icon>close</mat-icon>
        </button>
    }
</div>
